import http from "../utils/http";

function videoCatalog() {
	return http.get("video_catalog");
}

function getVideoRec() {
	return http.post("video_rec");
}

function videoList(data) {
	return http.post("video_list", data);
}

const videoApi = { getVideoRec, videoList, videoCatalog };

export default videoApi;
